// ############################################################################
// ## BOX ZOOMING #############################################################
// ############################################################################

import $ from "jquery"
import {$doc} from "./_globals.js";

$(function() {
  var unzoomOnEsc = null;

  document.addEventListener("keydown", function (evt) {
    if (evt.key === "Escape" && unzoomOnEsc) unzoomOnEsc();
  });

  $doc.on("click", "[data-box-zoom]", function () {
    var $box = $(this).closest(".box");
    var expandor = $box.find("[id$=_list]").data("expandor");

    function updateExpanded() {
      if (expandor) {
        if ($box.hasClass("box-zoomed")) $box.data("contract", expandor.expand());
        else if ($box.data("contract")) expandor.contract();
      }
      $('body').toggleClass('modal-open', $box.hasClass("box-zoomed"));
    }

    $box.toggleClass("box-zoomed").trigger("boxzoom");
    updateExpanded();
    if (!$box.hasClass("box-zoomed")) unzoomOnEsc = null;

    unzoomOnEsc = function () {
      $box.removeClass("box-zoomed");
      updateExpanded();
      unzoomOnEsc = null;
    };
  });
});
